import {
	ArrowRight,
	CalendarClock,
	MessageSquare,
	Sparkles,
} from "lucide-react";

type PromptCalendarSlot = {
	day: string;
	time: string;
	channel: string;
	title: string;
};

export function PromptCalendarExample({
	assistant = "AI assistant",
	prompt,
	response,
	slots,
}: {
	assistant?: string;
	prompt: string;
	response: string;
	slots: PromptCalendarSlot[];
}) {
	return (
		<div className="mx-auto grid max-w-4xl gap-px overflow-hidden rounded-md border border-border bg-border text-left md:grid-cols-[minmax(0,0.92fr)_minmax(0,1.08fr)]">
			<div className="space-y-4 rounded-md bg-white dark:bg-black p-5 sm:p-6">
				<div className="flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-muted-foreground">
					<MessageSquare className="size-4" />
					Live prompt
				</div>
				<div className="rounded-md border border-border bg-muted/30 p-4">
					<p className="text-sm leading-relaxed text-foreground">
						&ldquo;{prompt}&rdquo;
					</p>
				</div>
				<div className="flex items-start gap-3 rounded-md border border-border bg-background p-4">
					<span className="mt-0.5 flex size-7 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
						<Sparkles className="size-4" />
					</span>
					<div>
						<p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
							{assistant} response
						</p>
						<p className="mt-1 text-sm leading-relaxed text-muted-foreground">
							{response}
						</p>
					</div>
				</div>
			</div>
			<div className="rounded-md bg-white dark:bg-black p-5 sm:p-6">
				<div className="mb-4 flex items-center justify-between gap-4">
					<div className="flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-muted-foreground">
						<CalendarClock className="size-4" />
						Calendar output
					</div>
					<ArrowRight className="size-4 text-muted-foreground/50" />
				</div>
				<div className="grid gap-3">
					{slots.map((slot) => (
						<div
							key={`${slot.day}-${slot.time}-${slot.channel}`}
							className="grid grid-cols-[5.5rem_minmax(0,1fr)] gap-3 rounded-md border border-border bg-background p-3"
						>
							<div>
								<p className="text-sm font-medium text-foreground">
									{slot.day}
								</p>
								<p className="text-xs text-muted-foreground">{slot.time}</p>
							</div>
							<div>
								<p className="text-xs font-medium uppercase tracking-wider text-primary">
									{slot.channel}
								</p>
								<p className="mt-1 text-sm leading-snug text-muted-foreground">
									{slot.title}
								</p>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}
